(() => {
  class VehicleSpecs extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-vehicle-data]').textContent);
      this.show(this.data.initial);
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => { if (String(event.data.sectionId) === this.dataset.section) this.show(event.data.variant.id); });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    show(id) {
      const v = this.data.vehicles.find(v => String(v.id) === String(id)); if (!v) return;
      for (const [key,value] of Object.entries({name:v.name,seats:v.seats ? this.data.required : this.data.notRequired,size:v.size,weight:v.weight,access:v.access})) this.querySelector('[data-vehicle-'+key+']').textContent = value || this.data.pending;
    }
  }
  if (!customElements.get('lawson-vehicle-specs')) customElements.define('lawson-vehicle-specs',VehicleSpecs);
  function floorPhoto(map,id) {
    const v = map.variants.find(v => String(v.id) === String(id));
    const info = document.getElementById('MainProduct-'+map.section); if (!info || !v) return;
    let status = info.querySelector('[data-floor-photo-status]');
    if (!status) { status = document.createElement('p'); status.dataset.floorPhotoStatus = ''; status.setAttribute('role','status'); info.querySelector('media-gallery')?.after(status); }
    const gallery = info.querySelector('media-gallery');
    if (!gallery) return;
    gallery.hidden = !v.media;
    status.hidden = !!v.media; status.textContent = v.media ? '' : map.missing + ': ' + v.name;
    if (v.media) {
      if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(map.section+'-'+v.media,true);
      else customElements.whenDefined('media-gallery').then(() => floorPhoto(map,id));
    }
  }
  const maps = Array.from(document.querySelectorAll('[data-lawson-floor-media]')).map(n => JSON.parse(n.textContent));
  maps.forEach(m => floorPhoto(m,m.initial));
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.variantChange,event => { maps.filter(m => String(m.section) === String(event.data.sectionId)).forEach(m => floorPhoto(m,event.data.variant.id)); });
})();
